import React, { useState } from 'react';
import { Mail, Phone, MessageCircle, ChevronDown, Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import Header from './Header';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: '',
    city: '',
    comment: ''
  });
  const [dropdownOpen, setDropdownOpen] = useState({});
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleDropdown = (menu) => {
    setDropdownOpen(prev => ({
      ...prev,
      [menu]: !prev[menu]
    }));
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Message sent successfully!');
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-gray-300">
        <div className="pr-4 sm:pr-6 lg:pr-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center">
              <Link to="/">
                <img src="/logo.jpg" alt="Anand Rathi Logo" className="h-16 sm:h-20" />
              </Link>
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex space-x-4 lg:space-x-8 text-gray-800 font-semibold text-sm lg:text-base">
              <div className="relative">
                <button
                  onClick={() => toggleDropdown('group')}
                  className="flex items-center hover:text-yellow-700 transition"
                >
                  GROUP <ChevronDown className="ml-1 h-4 w-4" />
                </button>
                {dropdownOpen.group && (
                  <div className="absolute top-full left-0 mt-1 w-48 bg-white shadow-lg border rounded-md z-50">
                    <Link to="/about" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">About</Link>
                    <Link to="/leadership" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">Leadership</Link>
                    {/* <a href="#" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">Our Journey</a> */}
                  </div>
                )}
              </div>
              {/* <button className="flex items-center hover:text-yellow-700 transition">
                                  BUSINESSES
                              </button>
                              <button className="hover:text-yellow-700 transition">MEDIA</button>
                              <button className="flex items-center hover:text-yellow-700 transition">
                                  CAREER
                              </button> */}
              <Link to="/contact" className="hover:text-yellow-700 transition">CONTACT US</Link>
            </nav>

            {/* Mobile menu button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden p-2"
            >
              {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>

          {/* Mobile Navigation */}
          {mobileMenuOpen && (
            <div className="md:hidden py-4 border-t">
              <div className="space-y-2">
                <div>
                  <button
                    onClick={() => toggleDropdown('groupMobile')}
                    className="flex items-center justify-between w-full px-4 py-2 text-gray-800 hover:bg-gray-100"
                  >
                    GROUP <ChevronDown className="h-4 w-4" />
                  </button>
                  {dropdownOpen.groupMobile && (
                    <div className="pl-4 space-y-1">
                      <Link to="/about" className="block px-4 py-2 text-gray-600 hover:bg-gray-100">About</Link>
                      <Link to="/leadership" className="block px-4 py-2 text-gray-600 hover:bg-gray-100">Leadership</Link>
                      {/*<a href="#" className="block px-4 py-2 text-gray-600 hover:bg-gray-100">Our Journey</a>*/}
                    </div>
                  )}
                </div>
                {/*<button className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100">BUSINESSES</button>
                <button className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100">MEDIA</button>
                <button className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100">CAREER</button>*/}
                <Link to="/contact" className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100">CONTACT US</Link>
              </div>
            </div>
          )}
        </div>
      </header>

      {/* Hero Image */}
      <div className="relative h-40 sm:h-48 lg:h-56 overflow-hidden">
        <img src="/contact-banner.png" alt="Contact Banner" className="w-full h-full object-cover" />
      </div>

      {/* Breadcrumb */}
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="text-sm text-gray-600">
          <span className="text-gray-900 font-semibold">Home</span>
          <span className="mx-2">/</span>
          <span className="text-amber-600">Contact</span>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 py-6 sm:py-8">
        <div className="mb-6 sm:mb-8">
          <h1 className="text-2xl sm:text-3xl font-semibold text-gray-800 mb-2">
            Anand Rathi Global Intermediaries Ltd.
          </h1>
          <div className="w-full h-1 bg-amber-600"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          {/* Left Column - Form */}
          <div className="order-2 lg:order-1">
            <p className="text-gray-700 mb-2 text-sm sm:text-base">Something else on your mind?</p>
            <p className="text-gray-600 mb-4 sm:mb-6 text-sm sm:text-base">Fill this form and we shall try and address it!</p>

            <form onSubmit={handleSubmit} className="space-y-3 sm:space-y-4">
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded focus:outline-none focus:border-amber-600 text-sm sm:text-base"
              />
              <input
                type="tel"
                name="mobile"
                placeholder="Mobile"
                value={formData.mobile}
                onChange={handleChange}
                className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded focus:outline-none focus:border-amber-600 text-sm sm:text-base"
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded focus:outline-none focus:border-amber-600 text-sm sm:text-base"
              />
              <input
                type="text"
                name="city"
                placeholder="City"
                value={formData.city}
                onChange={handleChange}
                className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded focus:outline-none focus:border-amber-600 text-sm sm:text-base"
              />
              <textarea
                name="comment"
                placeholder="Comment"
                value={formData.comment}
                onChange={handleChange}
                rows="4"
                className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded focus:outline-none focus:border-amber-600 text-sm sm:text-base"
              ></textarea>

              {/*<div className="flex items-center gap-2 text-xs sm:text-sm text-gray-600 my-3 sm:my-4">
                <input type="checkbox" className="w-4 h-4" />
                <span>JvDhyv</span>
              </div>*/}

              <p className="text-xs text-gray-600 mb-3 sm:mb-4 leading-relaxed">
                By Submitting the form you are authorising Anand Rathi to call you and send Promotional communication even though you being registered under DNC.
              </p>

              <button
                type="submit"
                className="w-full sm:w-auto px-6 sm:px-8 py-2 sm:py-3 bg-gray-200 text-gray-700 rounded hover:bg-gray-300 transition-colors text-sm sm:text-base"
              >
                Send Message
              </button>
            </form>
          </div>

          {/* Right Column - Illustration */}
          <div className="flex items-start justify-center order-1 lg:order-2">
            <img src="/contact-illustration.png" alt="Contact Illustration" className="w-full max-w-xs sm:max-w-sm lg:max-w-md h-auto" />
          </div>
        </div>

        {/* Escalation Section - Full Width */}
        <div className="mt-8 space-y-4 text-sm text-gray-700">
          <h1 className="text-2xl sm:text-3xl font-semibold text-gray-800 mb-2">Escalation:</h1>
          <p>In case of any trading related grievances, you may write to us at <a href="mailto:argilgrievance@rathi.com" className="text-blue-600 hover:underline">argilgrievance@rathi.com</a>.</p>

          <p>If you do not receive a satisfactory response within 3 working days, you may escalate your grievance to the following escalation levels:</p>

          <div className="overflow-x-auto">
            <table className="w-full border-collapse border border-gray-300 text-xs sm:text-sm">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border border-gray-300 px-3 py-2 text-left">Level</th>
                  <th className="border border-gray-300 px-3 py-2 text-left">Contact Person</th>
                  <th className="border border-gray-300 px-3 py-2 text-left">Address</th>
                  <th className="border border-gray-300 px-3 py-2 text-left">Contact No.</th>
                  <th className="border border-gray-300 px-3 py-2 text-left">Email ID</th>
                  <th className="border border-gray-300 px-3 py-2 text-left">Working Hours</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-gray-300 px-3 py-2">Level 1</td>
                  <td className="border border-gray-300 px-3 py-2">Ms. Neha Ghadi</td>
                  <td className="border border-gray-300 px-3 py-2">Express Zone, A Wing, 10th Floor, Western Express Highway, Goregaon East, Mumbai 400063</td>
                  <td className="border border-gray-300 px-3 py-2">022-6281 3793</td>
                  <td className="border border-gray-300 px-3 py-2"><a href="mailto:nehaghadi@rathi.com" className="text-blue-600 hover:underline">nehaghadi@rathi.com</a></td>
                  <td className="border border-gray-300 px-3 py-2">Monday-Friday from 9:30 a.m. to 6:30 p.m.</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-3 py-2">Level 2</td>
                  <td className="border border-gray-300 px-3 py-2">Mr. Ganesh Mangal (Compliance Officer)</td>
                  <td className="border border-gray-300 px-3 py-2">Express Zone, A Wing, 10th Floor, Western Express Highway, Goregaon East, Mumbai 400063</td>
                  <td className="border border-gray-300 px-3 py-2">022-6281 1516</td>
                  <td className="border border-gray-300 px-3 py-2"><a href="mailto:ganeshmangal@rathi.com" className="text-blue-600 hover:underline">ganeshmangal@rathi.com</a></td>
                  <td className="border border-gray-300 px-3 py-2">Monday-Friday from 9:30 a.m. to 6:30 p.m.</td>
                </tr>
              </tbody>
            </table>
          </div>

          <p>In absence of a response/complaint not addressed to your satisfaction, you may lodge a complaint with:</p>
          <ul className="list-disc list-inside space-y-1 pl-2">
            <li>SEBI at <a href="https://scores.sebi.gov.in/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">https://scores.sebi.gov.in/</a></li>
            <li>SMARTODR Dispute Website : <a href="https://smartodr.in/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">https://smartodr.in/</a></li>
          </ul>

          <p className="font-medium">Please quote your Service Ticket/Complaint Ref No. while raising your complaint at SEBI SCORES/Exchange portal.</p>
        </div>
      </div>

      {/* Footer */}
            <footer className="bg-gradient-to-br from-[#3a4a22] to-[#5a6a3a] text-white">
              <div className="container mx-auto px-4 py-8">
                <div className="grid md:grid-cols-4 gap-8 mb-6">
                  <div className="flex">
                    <div className="w-1 bg-white mr-4"></div>
                    <div>
                      <h4 className="text-white font-bold mb-4 font-sans">REGISTERED OFFICE:</h4>
                      <p className="text-sm text-[#D4C4A8] leading-relaxed font-sans">
                        1003 to 1012, 10th Floor, <br />
                          Dalal Street Commercial Cooperative Society Ltd.<br />
                          Block 53E, Zone-5, Road-5E, Gift City,<br />
                          District - Gandhinagar, Gujarat - 382355
                      </p>
                      <p className="text-sm text-[#D4C4A8] leading-relaxed font-sans mt-2">
                        Contact No. 022 6281 7003
                      </p>
                    </div>
                  </div>
                  <div className="flex">
                    <div className="w-1 bg-white mr-4"></div>
                    <div>
                      <h4 className="text-white font-bold mb-4 font-sans">QUICK LINKS</h4>
                      <div className="space-y-2 text-sm font-sans">
                        <Link to="/kyc-vernacular-language" className="block text-[#D4C4A8] hover:text-white transition">KYC Vernacular Language</Link>
                        <a href="https://smartodr.in/login" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">ODR Portal</a>
                        <a href="https://eservices.nsdl.com" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">NSDL E-Voting</a>
                        <a href="https://evoting.cdslindia.com/Evoting/EvotingLogin" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">CDSL E-Voting</a>
                      </div>
                    </div>
                  </div>
                  <div className="flex">
                    <div className="w-1 bg-white mr-4"></div>
                    <div>
                      <h4 className="text-white font-bold mb-4 font-sans">OTHER LINKS</h4>
                      <div className="space-y-2 text-sm font-sans">
                        <a href="#" className="block text-[#D4C4A8] hover:text-white transition">Companies and Associate Details</a>
                        <a href="#" className="block text-[#D4C4A8] hover:text-white transition">Company Profile</a>
                        <Link to="/client-bank-details" className="block text-[#D4C4A8] hover:text-white transition">Client Bank Details</Link>
                        <Link to="/advisory-on-impersonation" className="block text-[#D4C4A8] hover:text-white transition">Advisory on Impersonation</Link>
                        <Link to="/advisory-for-investors" className="block text-[#D4C4A8] hover:text-white transition">Advisory for Investors</Link>
                        <Link to="/investor-complaints" className="block text-[#D4C4A8] hover:text-white transition">Complaints</Link>
                        <Link to="/risk-disclosure-on-derivatives" className="block text-[#D4C4A8] hover:text-white transition">Risk Disclosure on Derivatives</Link>
                        <a href="/PDF/UPI-Handle.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">Transfer of funds via SEBI-validated UPI ID</a>
                      </div>
                    </div>
                  </div>
                  <div className="flex">
                    <div className="w-1 bg-white mr-4"></div>
                    <div>
                      <h4 className="text-white font-bold mb-4 font-sans">DOWNLOADS</h4>
                      <div className="space-y-2 text-sm font-sans">
                                                                                    <a href="/ARGIL-CRF-Form.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">CRF Form</a>
                                                                                    <a href="/Investor-Charter.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">Investor Charter</a>
                                                                                    <a href="/PDF/RMS-Policy_merged.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">RMS Policy</a>
                                                                                    <Link to="/privacy-policy" className="block text-[#D4C4A8] hover:text-white transition">Privacy Policy</Link>
                                                                                    <a href="/PDF/Surveillance-Policy.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">Surveillance Policy</a>
                                                                                    <a href="/PDF/new-Client-Code-Modification-Policy.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">Client Code Modification Policy</a>
                                                                                    <a href="/PDF/new-PMLA-Policy.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">AML Policy</a>
                                                                                    <a href="/PDF/Policy-regarding-pre-funded-instruments.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">Policy Regarding Pre-Funded Instruments</a>
                                                                                    <a href="/PDF/Policy-for-treatment-of-inactive-accounts.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">Policy for Treatment of Inactive Accounts</a>
                                                                                  </div>
                    </div>
                  </div>
                </div>
              </div>
      
              <div className="bg-gradient-to-b from-gray-700 to-gray-800 py-6">
                <div className="container mx-auto px-4">
                  <div className="space-y-4 text-xs text-gray-300 font-sans">
                    <div>
                      <p className="font-semibold text-white mb-2">Anand Rathi Global Intermediaries Ltd.</p>
                      <p>CIN : U66120GJ2024PLC148630</p>
                      <p>SEBI Registration No.: INZ000327038 (NSE- 90408)</p>
                    </div>
      
                    <div>
                      <p className="font-semibold text-white mb-2">Disclaimer:</p>
                      <div className="space-y-2 leading-relaxed">
                        <p>
                          Equity: Investment in securities market are subject to market risks, read all the related documents carefully before investing.
                          The securities are quoted as an example and not as a recommendation.
                        </p>
                        <p>
                          Mutual Funds: Mutual fund investments are subject to market risks, read all scheme related documents carefully before investing.
                        </p>
                        <p>
                          Certification/Registration granted by SEBI and certification from NISM is in no way a guarantee of performance of the intermediary or provides any assurance of returns to investors.
                        </p>
                      </div>
                    </div>
      
                    <div>
                      <p className="font-semibold text-white mb-3">Attention Investors:</p>
                      <ul className="space-y-1 leading-relaxed">
                        <li>• For all communication related to vulnerability reporting, security alerts, or any other suspicious activity related to cyber security, contact argil@rathi.com</li>
                        <li>• For any complaints email at <a href="mailto:argilgrievance@rathi.com" className="text-yellow-400 hover:text-yellow-300">argilgrievance@rathi.com</a></li>
                        <li>• Filing of complaints on <a className="text-yellow-400 hover:text-yellow-300" href="https://scores.sebi.gov.in/" traget="_blank">SCORES portal</a> – Easy & quick a. Register on SCORES portal b. Mandatory details for filing complaints on SCORES: I. Name, PAN, Address, Mobile Number, Email ID c. Benefits: I. Effective communication ii. Speedy redressal of the grievances.</li>
                        <li>• Stock Brokers can accept securities as margin from clients only by way of pledge in the depository system w.e.f. September 1, 2020. </li>
                        <li>• Update your mobile number & email Id with your stock broker / depository participant and receive OTP directly from depository</li>
                        <li>• Pay 20% upfront margin of the transaction value to trade in cash market segment</li>
                        <li>• Check your Securities /MF/ Bonds in the consolidated account statement issued by NSDL/CDSL every month</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </footer>
    </div>
  );
}